export default "/_next/static/images/wishlist-modal-6ec7a49f2c20d4b5a20d650a4018a758.png";